export default __webpack_public_path__ + "static/media/8t.0faf41ad.jpg";